import { ieee, mla, mla7 } from './styleConstants'

export const freeUseTextList = [
  ['ieee-asme-transactions-on-mechatronics', 'magazine'],
  [ieee, 'chapter'],
  [ieee, 'congress'],
  [ieee, 'encyclopedia'],
  [ieee, 'federal bill'],
  [ieee, 'introduction'],
  [ieee, 'map'],
  [mla, 'book'],
  [mla, 'chapter'],
  [mla, 'congress'],
  [mla, 'digital file'],
  [mla, 'encyclopedia'],
  [mla, 'federal bill'],
  [mla, 'introduction'],
  [mla, 'map'],
  [mla7, 'brochure'],
  [mla7, 'magazine'],
]

export const freeUseTextDesc = (style: string, source: string): string => {
  return `Use our free ${source} citation generator to generate ${style}-style references and citations. No more learning rules; just trust the tool for accurate citations.`
}
